import { BookingTable } from "@/app/Dashboard/Components/BookingTable";
import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { BookingStatus, TaskStatus } from "@/gql/graphql";
import { TaskList } from "@/app/Tasks/Components/TaskList";

export function AdminReportingScreen() {
  return (
    <FullPageScreen className="space-y-6">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink
              from="/$tenant/$orgId/supplier/{-$supplierId}"
              to="/$tenant/$orgId/supplier/{-$supplierId}/reports"
              params={(prev) => prev}
            >
              Reporting
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Admin</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <BookingTable
        id="bookings"
        title="Bookings Without Payments"
        searchable={false}
        defaultState={{
          statuses: [
            BookingStatus.Confirmed,
            BookingStatus.Accepted,
            BookingStatus.Vip,
            BookingStatus.AwaitingConfirmation,
          ],
        }}
        queryVariables={{
          hasNoCustomerPayments: true,
        }}
      />

      <TaskList
        id="admin-all-tasks"
        queryVariables={{
          orgOnly: false,
          status: [TaskStatus.Pending, TaskStatus.Overdue],
        }}
      />
    </FullPageScreen>
  );
}
